import { FormikHelpers } from 'formik';
import React from 'react';
import { ButtonPrimary, Button, Form, InputText } from '../../../components-v2/shared';
import styles from '../email-editor.module.scss';

export const EmailEditorNameForm: React.FC<{
    name: string;
    onSubmit: (values: { name: string }, formikHelpers: FormikHelpers<{ name: string }>) => void;
    onCancel: () => void;
}> = ({ name, onSubmit, onCancel }) => {
    return (
        <Form className={styles['email-editor-edit-name-form']} initialValues={{ name }} onSubmit={onSubmit}>
            {formikProps => (
                <>
                    <InputText
                        label="Edit Email Template Name"
                        className={styles['email-editor-edit-name-input']}
                        name="name"
                        formikProps={formikProps}
                    />
                    <ButtonPrimary className={styles['email-editor-edit-name-save-button']} type="submit">
                        Save
                    </ButtonPrimary>
                    <Button className={styles['email-editor-edit-name-cancel-button']} onClick={onCancel}>
                        Cancel
                    </Button>
                </>
            )}
        </Form>
    );
};
